<script setup lang="ts">
import { computed } from 'vue';
import { FhBadge, FhTooltip, FhText } from '@fareharbor-com/beacon-vue';
import { useAvailabilities } from '@/composables/useAvailabilities';

interface ItemAvailabilityProps {
  availabilityCount: number | null;
}

const props = defineProps<ItemAvailabilityProps>();

const { getAvailabilityClassification } = useAvailabilities();

const availabilityClassification = computed(() =>
  getAvailabilityClassification(props.availabilityCount),
);

const tooltipText = computed(() => {
  if (
    props.availabilityCount === null ||
    props.availabilityCount === undefined
  ) {
    return 'Availability data not available';
  }
  return `${props.availabilityCount} availabilities in next 6 months`;
});
</script>

<template>
  <FhTooltip placement="top">
    <FhBadge :variant="availabilityClassification.variant" size="sm">
      {{ availabilityClassification.label }}
    </FhBadge>
    <template #content>
      <FhText variant="body-sm">
        {{ tooltipText }}
      </FhText>
    </template>
  </FhTooltip>
</template>
